import { observer } from 'mobx-react-lite';
import React from 'react';
import { CsvReadFile } from 'src/AppState/PromotionQuestionsState/PromotionQuestionsState';
import { DnDAreaV2 } from './DnDAreaV2';
import { FileUploadingV2 } from './FileUploadingV2';
import { FileUploadedV2 } from './FileUploadedV2';
import { FormInputState } from 'src_common/common/mobx-utils/Form2/FormInputState';

interface PropsType {
    state: FormInputState<boolean, boolean>;
    maxFileSize?: number;
    hideMaxSizeInfo?: boolean;
    allowedFileTypes: string[];
    allowedMimeTypes: string[];
    file: CsvReadFile | null;
    onSelectFile: (files: File[]) => Promise<void>;
    onReplace?: (event: React.SyntheticEvent) => Promise<void>;
    onRemove: () => void;
    uploadingFileName?: string | null;
    label?: string;
    placeholder: string;
}

export const UploaderV2 = observer((props: PropsType) => {
    const { allowedMimeTypes, onSelectFile, onReplace, onRemove, uploadingFileName, file, label, state } = props;

    if (uploadingFileName !== null && uploadingFileName !== undefined) {
        return <FileUploadingV2 fileName={uploadingFileName} />;
    }

    return (
        <div>
            <label className='text-sm'>{label}</label>

            {file !== null && state.value === true && onReplace !== undefined ? (
                <FileUploadedV2
                    fileName={file.fileName}
                    uploadedAt={file.uploadedAt}
                    onReplace={onReplace}
                    onRemove={onRemove}
                />
            ) : (
                <div className='flex justify-between items-center flex-1'>
                    <DnDAreaV2
                        onDrop={onSelectFile}
                        label={props.placeholder}
                        allowedMimeTypes={allowedMimeTypes}
                    />
                </div>
            )}
        </div>
    );
});
